import { IGetAllOrdemCompraUseCase } from "../../../presentation/useCases/read/get_all_ordem_compra_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { OrdemCompraLista } from "../../models/ordem_compra_lista";
import { IComprasRepository } from "../../repositories/compras_repositories";
import { telaIdsToNumber, TelasIds } from "../../../../../common/utils/tela_ids";

/**
 * GetAllOrdemCompraUseCase
 */

export class GetAllOrdemCompraUseCase extends BasePaginatedUseCase<OrdemCompraLista> implements IGetAllOrdemCompraUseCase {
  constructor(private readonly repository: IComprasRepository) {
    super();
  }

  async getAllOrdemCompra(
    telaId: TelasIds,
    centroCusto: number[] | null,
    fornecedor: number[] | null,
    coletaPreco: number[] | null,
    ordemCompra: number[] | null,
    produtoServico: number[] | null,
    status: number[] | null,
    statusNF: number | null,
    nroNotaFiscal: string | null,
    dataOCStart: Date | null,
    dataOCEnd: Date | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (statusNF === null) throw new Error('Status invalido!');

    const response = await this.repository.getAllOrdemCompra(
      telaIdsToNumber(telaId),
      centroCusto,
      fornecedor,
      coletaPreco,
      ordemCompra,
      produtoServico,
      status,
      statusNF,
      nroNotaFiscal,
      dataOCStart,
      dataOCEnd,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
